import { Services } from '@sigma-frontend-libs/commons'

import { components, labelModes } from '@/utils'

import catchSymbolsInput from '@/components/services/sendings/catchSymbolsInput'

export default function(h) {
  return h(
    catchSymbolsInput,
    {
      props: {
        value: this.proxy,
        sendingType: this.type,
        label: this.getTranslate(`${Services.sendings}.labels.text`),
        disabled: this.disabled,
        component: components.textarea,
        labelMode: labelModes.hidden,
        tags: this.tags,
        customMenu: this.customMenu,
        maxLength: this.maxLength,
        messagePayloadGenerator: true,
        utm: true,
        stats: true
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    }
  )
}
